import {
  LOAD_SUCCESS_GROUPES,
  LOAD_FAIL_GROUPES,
  SAVE_SUCCESS_GROUPES,
  SAVE_FAIL_GROUPES,
  UPDATE_SUCCESS_GROUPES,
  UPDATE_FAIL_GROUPES,
  DELETE_SUCCESS_GROUPES,
  DELETE_FAIL_GROUPES,
} from "../actions/groupeAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_GROUPES:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (item.groupe_id === action.payload.groupe_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_GROUPES:
      const filtered = state.data.filter((etape) => {
        return etape.groupe_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
